module.exports = __webpack_public_path__ + "img/00041.a9feabd5.webp";